/** Only this exact read-only operation may bypass the BOSS transport. */
export const LOTTERY_SCREEN_PATH =
  '/wanApi/conference/core/activityLottery/v1/getScreenSnapshot';

export const isLotteryScreenPath = (pathname: string) =>
  /^\/lottery-screen\/[A-Za-z0-9_-]+\/?$/.test(pathname);

export const readScreenCredential = (
  location: Pick<Location, 'pathname' | 'hash'>,
) => {
  if (!isLotteryScreenPath(location.pathname)) return undefined;
  const screenId = location.pathname.split('/')[2];
  const screenToken = new URLSearchParams(location.hash.slice(1)).get('token');
  if (!screenToken || !/^[A-Za-z0-9_-]{32,256}$/.test(screenToken)) return undefined;
  return { screenId, screenToken };
};

export class ScreenRequestError extends Error {
  constructor(readonly status: number) {
    super(
      status === 401 || status === 403
        ? '大屏链接已失效，请联系工作人员重新生成。'
        : '连接暂时中断，正在重新同步。',
    );
  }
}

/** The generator can pass arbitrary options; only data and signal are accepted. */
export async function request<T>(
  path: string,
  options: {
    data?: unknown;
    signal?: AbortSignal;
    [key: string]: unknown;
  } = {},
): Promise<T> {
  if (path !== LOTTERY_SCREEN_PATH) throw new Error('拒绝非大屏快照请求');
  const response = await fetch(LOTTERY_SCREEN_PATH, {
    method: 'POST',
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
    redirect: 'error',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Client-Type': 'H5',
    },
    body: JSON.stringify(options.data),
    signal: options.signal,
  });
  if (!response.ok) throw new ScreenRequestError(response.status);
  return response.json() as Promise<T>;
}
